import React, { useMemo, useState } from 'react';
import { useAvailableServicesQuery } from '../../../../../../graphql/graphql';
import Loading from '../../../../../../Components/Loading';
// @ts-ignore
import styles from './ManagerServicesList.module.scss';
import Text from '../../../../../../Components/Base/Text/Text';
import Button from '../../../../../../Components/Button/Button';
import { Theme } from '../../../../../../Enums/Theme.enum';
import ManagerHookUpCSSZModal from './ManagerHookUpCSSZModal';
import ManagerHookUpSUKLModal from './ManagerHookUpSUKLModal';

const ManagerServicesList: React.FC = () => {
	const [isCSSZOpen, setIsCSSZOpen] = useState(false);
	const [isSUKLOpen, setIsSUKLOpen] = useState(false);

	const { data, isLoading } = useAvailableServicesQuery();

	const services: { cssz: boolean; sukl: boolean } = useMemo(() => {
		if (data) {
			const termItems = data?.termItems?.data;
			return {
				cssz: termItems?.some(item => item?.value === 'csszAddress') || false,
				sukl: termItems?.some(item => item?.value === 'eErecept') || false,
			};
		}

		return {
			cssz: false,
			sukl: false,
		};
	}, [data]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<>
			<div className={styles.wrapper}>
				{services.cssz && (
					<div className={styles.item}>
						<div>
							<Text className={styles.title} tx='component.hookUp.cssz.text' />
							<Text
								className={styles.description}
								tx='component.hookUp.cssz.hint'
							/>
						</div>
						<div>
							<Button
								theme={Theme.BLUE}
								title='base.settings'
								onClick={() => setIsCSSZOpen(true)}
							/>
						</div>
					</div>
				)}
				{services.sukl && (
					<div className={styles.item}>
						<div>
							<Text className={styles.title} tx='component.hookUp.sukl.text' />
							<Text
								className={styles.description}
								tx='component.hookUp.sukl.hint'
							/>
						</div>
						<div>
							<Button
								theme={Theme.BLUE}
								title='base.settings'
								onClick={() => setIsSUKLOpen(true)}
							/>
						</div>
					</div>
				)}
			</div>
			{isCSSZOpen && (
				<ManagerHookUpCSSZModal
					isOpen
					onClose={() => setIsCSSZOpen(false)}
					onSave={() => setIsCSSZOpen(false)}
				/>
			)}
			{isSUKLOpen && (
				<ManagerHookUpSUKLModal
					isOpen
					onClose={() => setIsSUKLOpen(false)}
					onSave={() => setIsSUKLOpen(false)}
				/>
			)}
		</>
	);
};

export default ManagerServicesList;
